export default __webpack_public_path__ + "static/media/t4 (1).28595046.png";